import { createStyles, Theme } from '@material-ui/core';
import { StyleRules } from '@material-ui/styles';

export const styles = (theme: Theme): StyleRules =>
  createStyles({
    root: {
      margin: 0,
      padding: theme.spacing(2),
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: 10,
      color: theme.palette.grey[500],
    },
    headline: {
      color: theme.palette.grey[300],
    },
  });

export default { styles };
